











































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
@Component
export default class extends Vue {
  @Prop() audioItem!: any;
  @Prop() idx!: any;
  isDraging = false;
  loop = false;
  currentTime = "00:00";
  duration = "00:00";
  isPlaying = false;
  totalTime = 0;
  del(item: any, index: any) {
    this.$emit("del", item, index);
  }
  onChange() {
    const _t = this as any;
    const value = _t.$refs.range.value;
    const persentage = ((value / 360) * 100).toFixed(1) + "%";
    _t.$refs.range.style.backgroundSize = `${persentage} 100%`; //
    // 控制音频播放
    const timeToGo = (value / 360) * this.totalTime;
    const audio = _t.$refs.audio;
    audio.currentTime = timeToGo;
    _t.currentTime = _t.s_to_hs(timeToGo);
  }
  loadingFinish() {
    const _t = this as any;
    const totalTime = _t.$refs.audio.duration;
    this.totalTime = Number(totalTime);
  }
  playAudio(item: any, index: any) {
    const _t = this as any;
    const audios = document.getElementsByClassName("audio");
    const audio = _t.$refs.audio;
    _t.isDraging = false;
    [].forEach.call(audios, (i: any) => {
      if (i !== audio) {
        i.pause();
      } else {
        i.play();
        _t.isPlaying = true;
      }
    });
  }
  fillTime(e: any, index: any) {
    const _t = this as any;
    _t.duration = _t.s_to_hs(e.target.duration);
  }
  s_to_hs(s: any) {
    let h = 0 as any;
    h = Math.floor(s / 60);
    s = Math.floor(s % 60);
    h += "";
    s += "";
    h = h.length == 1 ? "0" + h : h;
    s = s.length == 1 ? "0" + s : s;
    return h + ":" + s;
  }
  audioPause() {
    this.isPlaying = false;
  }
  updateProgress(index: any) {
    const _t = this as any;
    if (_t.isDraging) {
      return false;
    }
    _t.throttle(() => {
      const audio = _t.$refs.audio;
      if (!audio.paused) {
        const currentTime = audio.currentTime; // 当前播放时间
        _t.currentTime = _t.s_to_hs(currentTime);
        // 改变进度条的值
        const range = _t.$refs.range;
        range.value = Math.floor((currentTime / _t.totalTime) * 360);
        // 进度条的值改变的时候，颜色也跟着变化
        const persentage =
          ((currentTime / _t.totalTime) * 100).toFixed(1) + "%";
        _t.$refs.range.style.backgroundSize = `${persentage} 100%`;
      }
    }, 800)();
  }
  throttle(func: any, wait: any) {
    const _t = this as any;
    return function () {
      const args = arguments;
      const now = Date.now();
      if (_t.previous) {
        if (now - _t.previous > wait) {
          typeof func === "function" && func.apply(_t, args);
          _t.previous = now;
        }
      } else {
        _t.previous = now;
      }
    };
  }
  audioEnded() {
    const _t = this as any;
    const audio = _t.$refs.audio;
    audio.pause();
    _t.isPlaying = false;
    _t.currentTime = "00:00";
    _t.$refs.range.value = 0;
    _t.$refs.range.style.backgroundSize = `0 100%`;
  }
  stopAudio() {
    const _t = this as any;
    const audio = _t.$refs.audio;
    audio.pause();
    _t.isPlaying = false;
  }
  clickLoop() {
    const _t = this;
    if (_t.loop) {
      _t.loop = false;
    } else {
      _t.loop = true;
    }
  }
}
